import React from 'react';
import { useTranslation } from 'react-i18next';
import doneImg from 'themes/disonaTheme/icons/deposit/successful-transaction-icon.svg';
import warnImg from 'themes/disonaTheme/icons/deposit/unsuccessful-transaction-icon.svg';
import routes from 'common/constants/routing.constants';

import { S } from './styled';

export const InfoPagesLayoutDisona = ({
  children,
  error,
  to = routes.auth.login.path,
  linkText = 'Back to Operation',
  currency,
  amount,
}) => {
  const { t } = useTranslation();
  return (
    <S.CTAContainer>
      <S.Body>

        <S.Main>
          <S.Header>
            {error ? (
              <h2>{t('common.disona.transactionStatus.errorText')}</h2>
            ) : (
              <h2>{t('common.disona.transactionStatus.successText')}</h2>
            )}
          </S.Header>

          <S.Content>
            {!error && <S.DoneImg src={doneImg} />}
            {error && <S.DoneImg src={warnImg} />}
            <S.Title>{children}</S.Title>
            <S.Description>
              {amount}
              {' '}
              {currency}
            </S.Description>
          </S.Content>
          <S.Footer>
            {
              window.top === window.self
              && <S.BackButton to={to}>{linkText}</S.BackButton>
            }
          </S.Footer>
        </S.Main>
      </S.Body>
    </S.CTAContainer>
  );
};
